const envApiUrl = import.meta.env.VITE_API_URL?.replace(/\/+$/, "") ?? "";

export function getApiBaseUrl(): string {
  if (envApiUrl) return envApiUrl;
  // Default to same-origin /api and let Vite proxy handle backend routing in dev.
  // This avoids CSP/CORS issues when connect-src is restricted to 'self'.
  return "";
}

export function resolveApiUrl(path: string): string {
  const normalizedPath = path.startsWith("/api/")
    ? path
    : `/api${path.startsWith("/") ? path : `/${path}`}`;
  const baseUrl = getApiBaseUrl();

  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath;
}